import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DataStorage } from "core/Misc/dataStorage.js";
import * as react from "react";
import downArrow from "../assets/imgs/downArrow.svg";
import { ContextMenu } from "shared-ui-components/fluent/primitives/contextMenu";
import { FluentToolWrapper } from "shared-ui-components/fluent/hoc/fluentToolWrapper";
export class LineContainerComponent extends react.Component {
    constructor(props) {
        super(props);
        const initialState = DataStorage.ReadBoolean(this.props.title, !this.props.closed);
        this.state = { isExpanded: initialState };
    }
    switchExpandedState() {
        const newState = !this.state.isExpanded;
        DataStorage.WriteBoolean(this.props.title, newState);
        this.setState({ isExpanded: newState });
    }
    renderHeader() {
        const className = this.state.isExpanded ? "collapse" : "collapse closed";
        const header = (_jsxs("div", { className: "header", onClick: () => this.switchExpandedState(), children: [_jsx("div", { className: "title", children: this.props.title }), _jsx("div", { className: className, children: _jsx("img", { className: "img", title: this.props.title, src: downArrow }) })] }));
        if (this.props.contextMenuItems && this.props.contextMenuItems.length > 0) {
            return (_jsx(FluentToolWrapper, { toolName: "Smart Filter Editor", useFluent: true, children: _jsx(ContextMenu, { trigger: header, items: this.props.contextMenuItems }) }));
        }
        else {
            return header;
        }
    }
    render() {
        if (!this.state.isExpanded) {
            return (_jsx("div", { className: "paneContainer", children: _jsx("div", { className: "paneContainer-content", children: this.renderHeader() }) }));
        }
        return (_jsx("div", { className: "paneContainer", children: _jsxs("div", { className: "paneContainer-content", children: [this.renderHeader(), _jsx("div", { className: "paneList", children: this.props.children })] }) }));
    }
}
//# sourceMappingURL=lineContainerComponent.js.map